import Storage from './Storage';

/**
 * Store PublicAuth
 * 
 */
class PublicAuth extends Storage {
    storeName = 'public_auth_';
    hasOldKey = true;

    /**
     * PublicAuth constructor
     * 
     * @param {string} id client id
     */
     constructor(id) {
        super();
        this.id = id;
        this.setKey();
    }

    /**
     * @override
     * Format data for store
     * 
     * @param {*} data data to store
     * @param {boolean} data.success get request success status
     * @param {*} data.data data to store
     * @returns 
     */
     formatSetData(data) {
        let returnData = JSON.stringify({
            'authType': null,
            'success': (data.success) ? data.success : false,
            'message': '',
            'data':  ((data.success) && (data.data)) ? data.data : null,
            'timestamp': new Date().getTime()
        });
        return returnData;
    }

    /**
     *  @override
     * Format data for store
     * 
     * @param {*} data data to store
     * @returns 
     */
     formatSetDataOld(data) {
        let returnData = JSON.stringify(data);
        return returnData;
    }

}

export default PublicAuth;